import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web

/* ducks from @galo-monitor/stores */
import activity from '@galo-monitor/stores/activity'
import application from '@galo-monitor/stores/application'
import authentication from '@galo-monitor/stores/authentication'
import brand from '@galo-monitor/stores/brand'
import company from '@galo-monitor/stores/company'
import companyUser from '@galo-monitor/stores/companyUser'
import context from '@galo-monitor/stores/context'
import farm from '@galo-monitor/stores/farm'
import farmUser from '@galo-monitor/stores/farmUser'
import language from '@galo-monitor/stores/language'
import model from '@galo-monitor/stores/model'
import moduleReducer from '@galo-monitor/stores/module'
import plan from '@galo-monitor/stores/plan'
import property from '@galo-monitor/stores/property'
import rawMaterialsStocks from '@galo-monitor/stores/rawMaterialsStocks'
import role from '@galo-monitor/stores/role'

const rootPersistConfig = {
  key: 'root',
  storage
}

const authenticationPersistConfig = {
  key: 'authentication',
  storage
}

const contextPersistConfig = {
  key: 'context',
  storage
}

const farmPersistConfig = {
  key: 'farm',
  storage
}

const langPersisConfig = {
  key: 'language',
  storage
}

const rootReducer = combineReducers({
  activity,
  application,
  authentication: persistReducer(authenticationPersistConfig, authentication),
  brand,
  company,
  companyUser,
  context: persistReducer(contextPersistConfig, context),
  farm: persistReducer(farmPersistConfig, farm),
  language: persistReducer(langPersisConfig, language),
  model,
  module: moduleReducer,
  rawMaterialsStocks,
  role,
  farmUser,
  plan,
  property
})

export default persistReducer(rootPersistConfig, rootReducer)
